import type { ColumnDef } from "@tanstack/react-table";

// Resolves a column's plain-text label. Prefers `meta.label` (set on
// JSX-headed columns so the text is available without parsing JSX), then a
// string header, then a function header returning a string, then the caller-
// supplied fallback (typically the column id).
export const columnLabel = <T>(
    column: ColumnDef<T, any>,
    fallback: string,
): string => {
    if (column.meta?.label) {
        return column.meta.label;
    }
    const header = column.header;
    if (typeof header === "string") return header;
    const resolved = (header as any)?.();
    return typeof resolved === "string" ? resolved : fallback;
};
